import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

import { BASE_URL } from './helpers.js';

const AuthContext = createContext();

export const useAuth = () => {
    return useContext(AuthContext);
};

axios.defaults.withCredentials = true;

const getCSRFToken = async () => {
    await axios.get(`${BASE_URL}/sanctum/csrf-cookie`);
};

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const setToken = (token) => {
        localStorage.setItem('token', token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    };

    const clearAuth = () => {
        localStorage.removeItem('token');
        delete axios.defaults.headers.common['Authorization'];
        setCurrentUser(null);
    };

    const login = async (email, password) => {
        await getCSRFToken();
        const response = await axios.post(`${BASE_URL}/api/login`, { email, password });
        setToken(response.data.token);
        setCurrentUser(response.data.user);
    };

    const logout = () => {
        // Server-side token revocation is best-effort and must not block
        // logging out locally: the token may already be invalid, or the
        // network unavailable. Capture the header before clearAuth deletes it.
        const authHeader = axios.defaults.headers.common['Authorization'];
        if (authHeader) {
            axios.post(`${BASE_URL}/api/logout`, null, { headers: { Authorization: authHeader } })
                .catch((error) => console.warn('Server-side logout failed', error));
        }
        clearAuth();
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            // TODO: Get user
            setCurrentUser(true);
        }
        setLoading(false);
    }, []);

    const value = {
        currentUser,
        login,
        logout,
        clearAuth
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};
